import * as AUTH_SERVICES from "api/services/auth/auth.services";
import * as appRoutes from "config/routes.config";
import React, { FC, useCallback, useEffect, useRef, useState } from "react";
import { useSelector } from "react-redux";

import AppScreen from "../ScreenWithSidebar";

import { AutoComplete, Button, Select, Skeleton, Tooltip, notification } from "antd";
import AppResult from "components/appResults";
import Breadcrumbs from "components/breadcrumbs";
import s from "./style.module.css";

import axios from "axios";
import { calculateAvg } from "common/enums";
import AppButton from "components/libs/button";
import H1 from "components/libs/title";
import { useNavigate } from "react-router-dom";
import { useGetAllLevelsQuery } from "store/services/app/levels.services";
import { useGetRoomsQuery } from "store/services/teacher/classes.services";
import AlbertImage from "../../../assets/images/app/levieuxalbert.svg";
import Search from "../../../assets/images/app/search.svg";
import Star from "../../../assets/images/app/start.svg";
import StudentPicture from "../../../assets/images/students/student.svg";
import backgroundImage from "../../../assets/images/teacher/card.svg";


const TeacherStudents: FC = () => {
  //!HOOKS
  const auth = useSelector((state) => state.auth);
  const { user } = useSelector((state) => state.auth);
  const { userHavingCalendar, userTeachingOrganismClass } = useSelector((state) => state.app);
  const [page, setPage] = useState<any>(1);
  const [filteredStudents, setFilteredStudents] = useState<any>([]);
  const [studentsData, setStudentsData] = useState<any>([]);
  //const [searchStudentsData, setSearchStudentsData] = useState<any>([]);
  const [levels, setLevels] = useState<any>([]);
  const [loading, setLoading] = useState<boolean>(true);
  const { data: levelsData, isLoading, isError } = useGetAllLevelsQuery();
  const { data: rooms, refetch } = useGetRoomsQuery(auth?.user?._id);
  const navigate = useNavigate();

  const [userFound, setUserFound] = useState<boolean>(true);
  const [filteringBy, setFilteringBy] = useState<string>();

  const getStudents = async () => {
    setLoading(true);
    try {
      const students = await AUTH_SERVICES.getTeacherAllStudents(user?._id);
      if (students?.data) {
        setStudentsData(students?.data?.results);
        setFilteredStudents(students?.data?.results);
      } else {
        throw new Error("L'utilisateur n'existe pas");
      }
    } catch (error) { }
    finally {
      setLoading(false);
    }
  }

  const controllerRef = useRef<AbortController | null>(null);

  const FindStudent = useCallback(
    async (userNameOrEmail: string) => {
      if (!userFound) return;

      if (userNameOrEmail.length >= 3) {
        try {
          const res = await AUTH_SERVICES.getTeacherStudents(
            userNameOrEmail,
            user?._id,
            "1",
            { signal: controllerRef.current?.signal }
          );

          const data = res?.data?.results;
          setFilteredStudents(data);

          if (data.length === 0) {
            notification.info({
              message: "Information",
              description: "Utilisateur non trouvé : )",
              style: { width: 300 },
            });
            setUserFound(false);
          }
        } catch (error: any) {
          if (axios.isCancel(error) || error.name === "CanceledError") {
            setUserFound(false);
            return;
          }
        }
      } else {
        setFilteredStudents([]);
      }
    },
    [userFound, user?._id]
  );

  // Handle level change
  const handleLevelChange = (value: string) => {
    if (value !== undefined) {
      const filtered = studentsData.filter((student: any) => student.level?.title === value);
      setFilteredStudents(filtered);
    }
    else {
      setFilteredStudents([]);
      ///getStudents();
    }
  };

  // Handle class change
  const handleClassChange = (value: string) => {
    if (value) {
      // keep students that have at least one class with the given _id
      const filtered = studentsData.filter((student: any) =>
        student.classes?.some((cls: any) => cls._id === value)
      );
      setFilteredStudents(filtered);
    } else {
      setFilteredStudents([]);
      ///getStudents();
    }
  };

  const handleClassFiltering = useCallback(async () => {
    if (filteringBy) {
      if (filteringBy === "class") {
        setFilteringBy("");
        getStudents();
      }
      else {
        setFilteringBy("class");
      }
    }
    else {
      setFilteringBy("class");
    }
  },
    [filteringBy]
  );

  const handleParticularFiltering = useCallback(async () => {
    if (filteringBy) {
      if (filteringBy === "particular") {
        setFilteringBy("");
        getStudents();
      }
      else {
        setFilteringBy("particular");
      }
    }
    else {
      setFilteringBy("particular");
    }
  },
    [filteringBy]
  );

  // Filter class change
  const FilterByClass = () => {
    const filtered = studentsData.filter((student: any) =>
      student.classes?.some((cls: any) => cls._id !== "")
    );
    if (filtered) {
      setFilteredStudents(filtered);
    }
    else {
      setFilteredStudents([]);
    }
  };

  // Particular class change
  const FilterByParticular = () => {
    const filtered = studentsData.filter((student: any) =>
      student.classes?.some((cls: any) => cls._id === "")
    );
    if (filtered) {
      setFilteredStudents(filtered);
    }
    else {
      setFilteredStudents([]);
    }
  };

  useEffect(() => {
    if (filteringBy) {
      if (filteringBy === "class") {
        FilterByClass();
      }
      else {
        FilterByParticular();
      }
    }
  }, [filteringBy]);

  useEffect(() => {
    getStudents();
  }, [page]);

  useEffect(() => {
    if (!levelsData?.data) return;

    // Combine all levels into one array
    const levels = Object.values(levelsData.data).flat();

    setLevels(levels);
  }, [levelsData]);

  const [isMobile, setIsMobile] = useState(window.innerWidth <= 1050);
  const handleResize = () => {
    setIsMobile(window.innerWidth <= 1050);
  };
  window.addEventListener('resize', handleResize);

  return (
    <React.Fragment>
      <div style={{ marginTop: isMobile ? (!userHavingCalendar || userTeachingOrganismClass) ? "130px" : "70px" : "0px" }}>
        {!isMobile && <Breadcrumbs isStudents />}
        {user?.isActive && user?.step === "completed" ? <AppScreen>
          <div className={s.studentbox}>
            <div className={s.titleBox}>
              <div className={s.avatarBox}>
                <img src={StudentPicture} height={isMobile ? 25 : 55}></img>
              </div>
              Mes élèves
            </div>
            <div className={s.filterMainBox}>
              <div style={{ display: "flex", flexDirection: isMobile ? "column" : "row", width: isMobile ? "100%" : "70%", justifyContent: isMobile ? "center" : "flex-start" }}>
                <div style={{ display: "flex", flexDirection: "row", width: isMobile ? "100%" : "40%", justifyContent: isMobile ? "center" : "flex-start" }}>
                  <Select
                    showSearch
                    style={{ padding: "5px 0px 5px 0px", fontSize: isMobile ? "0.75em" : "16px", marginRight: "20px", width: "100%" }}
                    className={s.selectInput}
                    placeholder={<div className={s.placeholderStyleSelect}>Filtrer par niveau</div>}
                    optionFilterProp="children"
                    bordered={false}
                    allowClear
                    dropdownStyle={{ padding: "3px" }}
                    showArrow={true}
                    onChange={handleLevelChange}
                    onClear={() => { setFilteredStudents([]); getStudents(); }}
                  >
                    {levels.map((item: any, i: any) => (<Select.Option key={i} value={item.title}>{item.title}</Select.Option>))}
                  </Select>

                  <Select
                    showSearch
                    style={{ padding: "5px 0px 5px 0px", fontSize: isMobile ? "0.75em" : "16px", width: "100%" }}
                    className={s.selectInput}
                    placeholder={<div className={s.placeholderStyleSelect}>Filtrer par classe</div>}
                    optionFilterProp="children"
                    bordered={false}
                    allowClear
                    dropdownStyle={{ padding: "3px" }}
                    showArrow={true}
                    onChange={handleClassChange}
                    onClear={() => { setFilteredStudents([]); getStudents(); }}
                  >
                    {rooms?.data.map((item: any, i: any) => (<Select.Option key={i} value={item._id}>{item.title}</Select.Option>))}
                  </Select>
                </div>

                <div style={{ display: "flex", flexDirection: "row", width: isMobile ? "100%" : "auto", justifyContent: isMobile ? "center" : "flex-start", marginTop: isMobile ? "10px" : "0px" }}>
                  <div onClick={handleClassFiltering} style={{ padding: "5px 10px 5px 10px", fontSize: isMobile ? "0.75em" : "16px", height: isMobile ? "30px" : "40px", color: filteringBy === "class" ? "#FFF" : "#707070", background: filteringBy === "class" ? "#80b1b2" : "#FFF", border: "1px solid #E3E2E2", borderRadius: "24px", cursor: "pointer", width: "auto", marginLeft: "20px", textAlign: "center" }}>
                    Mes classes
                  </div>

                  <div onClick={handleParticularFiltering} style={{ padding: "5px 10px 5px 10px", fontSize: isMobile ? "0.75em" : "16px", height: isMobile ? "30px" : "40px", color: filteringBy === "particular" ? "#FFF" : "#707070", background: filteringBy === "particular" ? "#80b1b2" : "#FFF", border: "1px solid #E3E2E2", borderRadius: "24px", cursor: "pointer", width: "auto", marginLeft: "20px", textAlign: "center" }}>
                    Cours particuliers
                  </div>
                </div>
              </div>

              <div className={s.searchBox}>
                <AutoComplete
                  allowClear
                  bordered={false}
                  className={s.search}
                  style={{ margin: "0px", paddingLeft: "10px", paddingRight: "10px", width: "100%" }}
                  onChange={(value) => {
                    if (!value) {
                      setUserFound(true);
                      getStudents();
                      console.log("no value");
                      return;
                    }
                    if (userFound) {
                      FindStudent(value);
                    }
                  }}
                  placeholder={<div className={s.placeholderStyle}>Trouver un élève</div>}
                  showSearch={true}
                  onClear={() => {
                    setUserFound(true);
                    setFilteredStudents([]);
                    getStudents();
                  }}
                >
                </AutoComplete>
                <div className={s.searchIconBox}><img src={Search} height={isMobile ? 10 : 15} style={{ filter: 'brightness(0) invert(1)' }}></img></div>
              </div>
            </div>

            {loading ? <Skeleton active={true} /> : <div className={s.lineBox}>
              {filteredStudents?.length !== 0 && filteredStudents?.map((student: any, index: number) => (
                student?.roles[0] !== "teacher" && <div style={{ backgroundImage: `url(${backgroundImage})`, backgroundSize: "cover", backgroundPosition: "center" }} className={s.card} key={index} onClick={() => { navigate(`${appRoutes.TEACHER_STUDENT_HISTORY}/${student?.uid}`, { state: student }) }}>

                  <div className={s.detailsAvatarBox}><img src={student?.profile} height={isMobile ? 35 : 65} style={{ borderRadius: "50%" }}></img></div>

                  <div className={s.studentName}>{student?.firstname} {student?.lastname}</div>

                  <div className={s.levelBox}>
                    {student?.level?.title}
                  </div>

                  <Tooltip
                    placement="bottom"
                    color="#FFF"
                    style={{ padding: "0px", margin: "0px", height: "80px", borderRadius: "16px" }}
                    overlayStyle={{ padding: "0px", margin: "0px", height: "80px", borderRadius: "16px" }}
                    title={
                      <div className={s.tooltipBox}>
                        <div className={s.dashedBox}>
                          Cours
                          <div style={{ display: "flex", flexDirection: "row", alignItems: "center", justifyContent: "center", fontSize: isMobile ? "0.7em" : "12px" }}>
                            {Number(student?.rateCours).toString().includes(".") ? Number(student?.rateCours).toFixed(2) : student?.rateCours}
                            <img src={Star} height={10} className={s.rateBoxStarTooltip}></img>
                          </div>
                        </div>
                        <div className={s.dashedBox}>
                          Application
                          <div style={{ display: "flex", flexDirection: "row", alignItems: "center", justifyContent: "center", fontSize: isMobile ? "0.7em" : "12px" }}>
                            {Number(student?.rateApplication).toString().includes(".") ? Number(student?.rateApplication).toFixed(2) : student?.rateApplication}
                            <img src={Star} height={10} className={s.rateBoxStarTooltip}></img>
                          </div>
                        </div>
                        <div className={s.dashedBox}>
                          Exercice
                          <div style={{ display: "flex", flexDirection: "row", alignItems: "center", justifyContent: "center", fontSize: isMobile ? "0.7em" : "12px" }}>
                            {Number(student?.rateExercice).toString().includes(".") ? Number(student?.rateExercice).toFixed(2) : student?.rateExercice}
                            <img src={Star} height={10} className={s.rateBoxStarTooltip}></img>
                          </div>
                        </div>
                      </div>
                    }
                  >
                    <Button type="link" style={{ display: "flex", alignItems: "center", justifyContent: "center" }}>
                      <div className={s.studentAvgBox}>
                        Note moyenne
                        <span className={s.studentAvg}>{calculateAvg(student?.rateApplication, student?.rateExercice, student?.rateCours)}</span>
                        <img src={Star} height={isMobile ? 7 : 10} className={s.rateBoxStar}></img>
                      </div>
                    </Button>
                  </Tooltip>

                  {student?.classes && student?.classes.length !== 0 ? <div className={s.classBox}>
                    {student?.classes[0]?.title}
                  </div> : <div className={s.classBox}>
                    Cours particulier
                  </div>}

                  <button className={s.defaultButton} onClick={() => { navigate(`${appRoutes.TEACHER_STUDENT_HISTORY}/${student?.uid}`, { state: student }) }}>Historique de cours</button>
                </div>
              ))/*  : searchStudentsData?.length !== 0 ? searchStudentsData?.map((student: any, index: number) => (
                student?.roles[0] !== "teacher" && <div style={{ backgroundImage: `url(${backgroundImage})`, backgroundSize: "cover", backgroundPosition: "center" }} className={s.card} key={index} onClick={() => { navigate(`${appRoutes.TEACHER_STUDENT_HISTORY}/${student?.uid}`, { state: student }) }}>

                  <div className={s.detailsAvatarBox}><img src={student?.profile} height={isMobile ? 35 : 65} style={{ borderRadius: "50%" }}></img></div>

                  <div className={s.studentName}>{student?.firstname} {student?.lastname}</div>

                  <div className={s.levelBox}>
                    {student?.level?.title}
                  </div>

                  <Tooltip
                    placement="bottom"
                    color="#FFF"
                    style={{ padding: "0px", margin: "0px", height: "80px", borderRadius: "16px" }}
                    overlayStyle={{ padding: "0px", margin: "0px", height: "80px", borderRadius: "16px" }}
                    title={
                      <div className={s.tooltipBox}>
                        <div className={s.dashedBox}>
                          Cours
                          <div style={{ display: "flex", flexDirection: "row", alignItems: "center", justifyContent: "center", fontSize: isMobile ? "0.7em" : "12px" }}>
                            {Number(student?.rateCours).toString().includes(".") ? Number(student?.rateCours).toFixed(2) : student?.rateCours}
                            <img src={Star} height={10} className={s.rateBoxStarTooltip}></img>
                          </div>
                        </div>
                        <div className={s.dashedBox}>
                          Application
                          <div style={{ display: "flex", flexDirection: "row", alignItems: "center", justifyContent: "center", fontSize: isMobile ? "0.7em" : "12px" }}>
                            {Number(student?.rateApplication).toString().includes(".") ? Number(student?.rateApplication).toFixed(2) : student?.rateApplication}
                            <img src={Star} height={10} className={s.rateBoxStarTooltip}></img>
                          </div>
                        </div>
                        <div className={s.dashedBox}>
                          Exercice
                          <div style={{ display: "flex", flexDirection: "row", alignItems: "center", justifyContent: "center", fontSize: isMobile ? "0.7em" : "12px" }}>
                            {Number(student?.rateExercice).toString().includes(".") ? Number(student?.rateExercice).toFixed(2) : student?.rateExercice}
                            <img src={Star} height={10} className={s.rateBoxStarTooltip}></img>
                          </div>
                        </div>
                      </div>
                    }
                  >
                    <Button type="link" style={{ display: "flex", alignItems: "center", justifyContent: "center" }}>
                      <div className={s.studentAvgBox}>
                        Note moyenne
                        <span className={s.studentAvg}>{calculateAvg(student?.rateApplication, student?.rateExercice, student?.rateCours)}</span>
                        <img src={Star} height={isMobile ? 7 : 10} className={s.rateBoxStar}></img>
                      </div>
                    </Button>
                  </Tooltip>

                  <button className={s.defaultButton} onClick={() => { navigate(`${appRoutes.TEACHER_STUDENT_HISTORY}/${student?.uid}`, { state: student }) }}>Historique de cours</button>
                </div>
              )) : studentsData?.length > 0 ? (
                studentsData?.map((student: any, index: number) => (
                  student?.roles[0] !== "teacher" && <div style={{ backgroundImage: `url(${backgroundImage})`, backgroundSize: "cover", backgroundPosition: "center" }} className={s.card} key={index} onClick={() => { navigate(`${appRoutes.TEACHER_STUDENT_HISTORY}/${student?.uid}`, { state: student }) }}>

                    <div className={s.detailsAvatarBox}><img src={student?.profile} height={isMobile ? 35 : 65} style={{ borderRadius: "50%" }}></img></div>

                    <div className={s.studentName}>{student?.firstname} {student?.lastname}</div>

                    <div className={s.levelBox}>
                      {student?.level?.title}
                    </div>

                    <Tooltip
                      placement="bottom"
                      color="#FFF"
                      style={{ padding: "0px", margin: "0px", height: "80px", borderRadius: "16px" }}
                      overlayStyle={{ padding: "0px", margin: "0px", height: "80px", borderRadius: "16px" }}
                      title={
                        <div className={s.tooltipBox}>
                          <div className={s.dashedBox}>
                            Cours
                            <div style={{ display: "flex", flexDirection: "row", alignItems: "center", justifyContent: "center", fontSize: isMobile ? "0.7em" : "12px" }}>
                              {Number(student?.rateCours).toString().includes(".") ? Number(student?.rateCours).toFixed(2) : student?.rateCours}
                              <img src={Star} height={10} className={s.rateBoxStarTooltip}></img>
                            </div>
                          </div>
                          <div className={s.dashedBox}>
                            Application
                            <div style={{ display: "flex", flexDirection: "row", alignItems: "center", justifyContent: "center", fontSize: isMobile ? "0.7em" : "12px" }}>
                              {Number(student?.rateApplication).toString().includes(".") ? Number(student?.rateApplication).toFixed(2) : student?.rateApplication}
                              <img src={Star} height={10} className={s.rateBoxStarTooltip}></img>
                            </div>
                          </div>
                          <div className={s.dashedBox}>
                            Exercice
                            <div style={{ display: "flex", flexDirection: "row", alignItems: "center", justifyContent: "center", fontSize: isMobile ? "0.7em" : "12px" }}>
                              {Number(student?.rateExercice).toString().includes(".") ? Number(student?.rateExercice).toFixed(2) : student?.rateExercice}
                              <img src={Star} height={10} className={s.rateBoxStarTooltip}></img>
                            </div>
                          </div>
                        </div>
                      }
                    >
                      <Button type="link" style={{ display: "flex", alignItems: "center", justifyContent: "center" }}>
                        <div className={s.studentAvgBox}>
                          Note moyenne
                          <span className={s.studentAvg}>{calculateAvg(student?.rateApplication, student?.rateExercice, student?.rateCours)}</span>
                          <img src={Star} height={isMobile ? 7 : 10} className={s.rateBoxStar}></img>
                        </div>
                      </Button>
                    </Tooltip>

                    <button className={s.defaultButton} onClick={() => { navigate(`${appRoutes.TEACHER_STUDENT_HISTORY}/${student?.uid}`, { state: student }) }}>Historique de cours</button>
                  </div>
                ))
              ) : <div></div> */}
            </div>}
            {!loading && filteredStudents?.length === 0 /* && searchStudentsData?.length === 0 && studentsData?.length < 1 */ && <div className={s.emptyData}><AppResult status={"info"} title="Aucun élève" /></div>}
          </div>
        </AppScreen> : <AppScreen className={s.dashboard}>
          <H1 className={s.title}>Bienvenue {auth?.user?.firstname}</H1>
          <div className={s.dashboardUserBox}>
            <img src={AlbertImage} width={240} height={240} style={{ marginTop: "20px", marginBottom: "10px" }}></img>
            <p className={s.dashboardUserMessage} style={{ fontFamily: "CartoonFont" }}>Oups, tu n’as pas encore accès à cette fonctionnalité! <br />Patience... ton compte est en cours de validation. </p>
            {user?.step !== "completed" && <AppButton onClick={() => navigate(appRoutes.COMPLETE_PROFILE)}>Completer mon profil</AppButton>}
          </div>
        </AppScreen>}
      </div>
    </React.Fragment>
  );
};

export default TeacherStudents;
